<template>
  <div style="border: 1px solid #ccc" class="relative">
    <div v-if="disabled" class="disable-layer" />
    <Toolbar ref="toolbar" style="border-bottom: 1px solid #ccc" :editor="editor" :default-config="toolbarConfig" :mode="mode" />
    <Editor class="editor-cont" style="overflow-y: hidden;height: 300px;" :index="index" placeholder="placeholder" :value="value" :default-config="editorConfig" :mode="mode" @input="handleInput" @onCreated="onCreated" @onChange="onChange"/>
  </div>
</template>
 
<script>
// 引入包
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { uploadFile } from "@/assets/js/api";
// 上传文件的接口
// import { videoApi } from '@/api/video'
// 引入wangeditor/editor-for-vue的样式
import '@wangeditor/editor/dist/css/style.css'
// 上传文件的路径前缀
// import { baseUrl } from '@/utils/pictureUrl'
export default {
  name: 'WangEditor',
  components: { Editor, Toolbar },
  props: {
    value: String,
    disabled: Boolean,
    cusHeight: {
      type: String,
      default: '150px'
    },
    index:Number
  },
  data() {
    return {
      serverUrl:'',
      editor: null,
      html: '',
      // wangeditor/editor-for-vue的配置
      toolbarConfig: {
        toolbarKeys: [
          'bold',
          'underline',
          'italic',
          'through',
          'clearStyle',
          'color',
          'bgColor',
          'fontSize',
          // 'fontFamily',
          'justifyLeft',
          'justifyRight',
          'justifyCenter',
          'justifyJustify',
          'lineHeight',
          // 'header1',
          // 'header2',
          // 'header3',
          // 'header4',
          // 'header5',
          // 'bulletedList',
          // 'numberedList',
          'uploadImage'
          // "uploadVideo"
        ]
      },
      editorConfig: {
        placeholder: 'Dear Thomas,I am curious as to whether or not you are still planning to go on that sking trip with your family thiswinter vacation. I ask because, if you are not going, you might find this program I heard about today tobe interesting. Apparently, Westfield State University, our local college, is going to hold an art seminar forthirty students',
        MENU_CONF: {
          uploadImage: {
            // 自定义图片上传
            customUpload: (file, insertFn) => {
              console.log(this);
              
              this.$emit('imgUpload','1');
              const form = new FormData()
              form.append('file', file)
              uploadFile(form).then(response => {
                var res = response.data
                console.log(response,'=response==')
                if (res.code == 200) {
                  const url = 'https://pic.bi-rong.com/' + res.data.src;
                  // 将图片插入到文本框中
                  insertFn(url)
                }
              })
            }
          }
          // uploadVideo: {
          //   // 自定义图片上传
          //   async customUpload(file, insertFn) {
          //     uploadFile('', file).then(response => {
          //       const url = response.data
          //       insertFn(this.$getFilePath(url))
          //     })
          //   }
          // }

          // uploadImage: {
          //   async customUpload (file, insertFn) {
          //     const form = new FormData()
          //     form.append('file', file)
          //     // 发送post请求
          //     const instance = axios.create({
          //       baseURL: '后台上传文件地址',
          //       timeout: 1000,
          //       headers: {
          //         'token': '',//接口需要的token
          //         'Content-Type': 'application/json'
          //       }
          //     })
          //     instance.post('后台接上传文件口', form
          //     ).then(res => {
          //       let data = res.data.data
          //       console.log(data, 7777)
          //       //insertFn用于图片显示在编辑器上
          //       insertFn(
          //         `后台文件下载的地址?id=${data.id}`, '', `后台文件下载的地址?id=${data.id}`)
          //         })
          //       .catch(err => console.log(err, 888))
          //   }
          // } 
        }
      },
      mode: 'default', // or 'simple'
    }
  },
  mounted() {
    var url = '';
    if(window.location.origin == 'https://orgp.zens10.com'){
      url = 'https://apps.zens10.com/'
    } else if(window.location.origin == 'https://org.zens10.com'){
      url = 'https://app.zens10.com/'
    } else {
      url = 'https://lite.zens10.com/'
    };
    this.serverUrl = url + '/ent/Upload/uploadFile';
  },
  created() {},
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      // console.log('this.editor :>> ', this.editor.getAllMenuKeys());
    },
    handleInput(value) {
      // 将文本内容传给父组件（引用这个组件的vue文件的）
      // console.log(value.indexOf('<div style="word-break: break-word;">'),'==33333==')
      // value = '<div style="word-break: break-word;">' + value + '</div>'
      value = value.replaceAll('<p>','<p style="word-break: break-word;">');
      console.log(value,this.index)
      this.$emit('input', value,this.index)
    },

    onChange(editor) {
      const text = editor.getHtml()
      this.$emit('update:content', text)
    },
  }
}
</script>

<style>
  .relative{
    width: 100%;
  }

  .relative p{
    display: block;
    padding: 0;
  }
  .w-e-text-placeholder{
    font-size: 14px;
  }

  h1{
    font-size: 50px;
  }
  h2{
    font-size: 40px;
  }
  h3{
    font-size: 30px;
  }
  h4{
    font-size: 20px;
  }
  h5{
    font-size: 10px;
  }
</style>
 



// WEBPACK FOOTER //
// src/components/comment/wangeditor.vue